<template>
    <div class="ShopStar">
        <div v-for="i in count">
            <img class="star" v-if="i <= num" src="@/assets/shop/Star.png" alt="">
            <img class="star" v-else src="@/assets/shop/Star_gray.png" alt="">
        </div>
        
    </div>
</template>
<script>
export default {
    name:'ShopStar',
    props:{
        num:{
            type:Number,
            default:1,
        }
    },
    data(){
        return {
            count:5,
        }
    },
    methods:{

    }
}
</script>
<style lang="scss" scoped>
    .ShopStar{
        display: flex;
        align-items: center;
        gap:0.25rem;
        .star{
            width: 1rem;
            height: 1rem;
            display: block;
        }
    }
</style>
